import React, { useMemo, memo } from "react";
import PropTypes from "prop-types";

import { formatNumber, CurrencySymbols } from "widgets/inputs";

import styles from "./style.css";

export function CurrencyComponent(props) {
  const { value = "", column } = props;
  const decimal =
    column.Decimalpoint ||
    (column.modelConfig && column.modelConfig.Decimalpoint);
  const currencyCode = value && value?.split(" ")[1];
  const formattedValue = useMemo(
    function formatValue() {
      if (value) {
        let temp = formatNumber(value?.split(" ")[0], decimal, currencyCode);
        return temp?.split(" ")[1];
      }
      return "";
    },
    [value, decimal, currencyCode]
  );
  const currencySymbol = useMemo(
    function getCurrencySymbol() {
      if (formattedValue && currencyCode) {
        let _symbol = CurrencySymbols[currencyCode] || currencyCode;
        return _symbol;
      }
      return "";
    },
    [formattedValue, currencyCode]
  );

  return (
    <span className={`${styles.currency}`}>
      <span className={`${styles.currencyValue} ellipsis`}>
        {currencySymbol
          ? `${currencySymbol} ${formattedValue}`
          : formattedValue}
      </span>
      {currencyCode && (
        <span className={`${styles.currencyCode} small`}>{currencyCode}</span>
      )}
    </span>
  );
}

CurrencyComponent.propTypes = {
  value: PropTypes.string,
  column: PropTypes.any
};

export const Currency = memo(CurrencyComponent);
